import { render, staticRenderFns } from "./Analysis.vue?vue&type=template&id=5391d79e"
import script from "./Analysis.vue?vue&type=script&lang=js"
export * from "./Analysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5391d79e')) {
      api.createRecord('5391d79e', component.options)
    } else {
      api.reload('5391d79e', component.options)
    }
    module.hot.accept("./Analysis.vue?vue&type=template&id=5391d79e", function () {
      api.rerender('5391d79e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/Analysis.vue"
export default component.exports